import { Outlet } from "react-router-dom";

import { FilterContractProvider } from "./filter-contract/filter-contract.context";
import './contract.scss';

export function Contract() {
  return (
    <div id="ShellContract" className="contract">
       <FilterContractProvider>
        <Outlet />
      </FilterContractProvider>
    </div>
  );
}

export default Contract;
